import type * as Types from 'app/types/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { ThemeSelectFragmentDoc } from '../fragments/theme.generated';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.ThemeOrder>;
  where?: Types.InputMaybe<Types.ThemeWhereInput>;
}>;

export type ThemesQueryResponse = {
  themes?: Types.Maybe<
    Pick<Types.ThemeConnection, 'totalCount'> & {
      edges?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<Types.ThemeEdge, 'cursor'> & {
              node?: Types.Maybe<
                Pick<
                  Types.Theme,
                  | 'createdAt'
                  | 'id'
                  | 'isGlobal'
                  | 'isPublished'
                  | 'name'
                  | 'thumbnail'
                  | 'updatedAt'
                >
              >;
            }
          >
        >
      >;
      pageInfo: Pick<
        Types.PageInfo,
        'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
      >;
    }
  >;
};

export const ThemesDocument = `
    query Themes($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: ThemeOrder, $where: ThemeWhereInput) {
  themes(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    edges {
      cursor
      node {
        ...ThemeSelect
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${ThemeSelectFragmentDoc}`;

export const useThemesQuery = <TData = ThemesQueryResponse, TError = unknown>(
  variables?: ThemesQueryVariables,
  options?: UseQueryOptions<ThemesQueryResponse, TError, TData>,
) => {
  return useQuery<ThemesQueryResponse, TError, TData>(
    variables === undefined ? ['Themes'] : ['Themes', variables],
    appFetcher<ThemesQueryResponse, ThemesQueryVariables>(ThemesDocument, variables),
    options,
  );
};

useThemesQuery.getKey = (variables?: ThemesQueryVariables) =>
  variables === undefined ? ['Themes'] : ['Themes', variables];
